export default "__VITE_ASSET__Kr8lH$bU__"